import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { EnumStepFunctions } from '../shared/enums/step-functions.enum';
import { IWebSocketParams } from '../shared/interfaces/web-socket-params.interface';
import { IWebSocketPseSendMessage } from '../shared/interfaces/web-socket-pse-send-message.interface';
import { CustomerDataService } from '../shared/services/customer-data.service';
import { LoadingService } from '../shared/services/loading.service';
import { WebSocketService } from '../shared/services/web-socket.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketPseService {
  response: any;
  stepFunctionSub: Subscription = new Subscription();

  constructor(
    public webSocketService: WebSocketService,
    public customerData: CustomerDataService,
    private loadingService: LoadingService
  ) {}

  connectWebSocket(webSocketParams: IWebSocketParams): void {
    this.webSocketService.wsBuild(webSocketParams);
  }

  waitStepEndProcess(): Observable<any> {
    this.loadingService.startLoading();

    return this.webSocketService
      .wsGetMessages$(EnumStepFunctions.StepEndProcess)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.stopLoading();
          this.webSocketService.wsComplete();
        })
      );
  }

  sendMessage(msj: IWebSocketPseSendMessage) {
    this.webSocketService.wsSendMessage(msj);
  }
}
